import React from 'react';
import { Card, Badge, Space, Input, Tooltip, Button } from 'antd';
import { DeleteOutlined, CalendarOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { formatDate, getServiceStatus } from "../../../helpers/helper";

const { Text } = Typography;
const { TextArea } = Input;

const ObjectCard = ({ obj, teamIndex, onCommentChange, onRemove }) => (
    <Card
        key={obj.id}
        size="small"
        style={{ marginBottom: 8 }}
    >
        <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ position: 'absolute', right: '10px' }}>
                <Tooltip title="Удалить из команды" key="delete">
                    <Button
                        type="text"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => onRemove(teamIndex, obj.id)}
                        style={{ height: 24, width: 24, minWidth: 24 }}
                    />
                </Tooltip>
            </div>
            <div>
                <Text strong>{obj.name}</Text>
                <Badge
                    status={getServiceStatus(obj.date_last_service)}
                    style={{ marginLeft: 8 }}
                />
            </div>
            <Text type="secondary">{obj.long_name || obj.district}</Text>
            <Text type="secondary" style={{ fontSize: '12px', marginBottom: '5px' }}>
                <CalendarOutlined /> {formatDate(obj.date_last_service)}
            </Text>
            <TextArea
                placeholder="Комментарий к объекту"
                value={obj.comment}
                onChange={(e) => onCommentChange(teamIndex, obj.id, e.target.value)}
                rows={2}
            />
        </div>
    </Card>
);

export default ObjectCard;